import { combineReducers } from 'redux';

import auth from './auth/reducer';
import user from './user/reducer';
import utils from './utils/reducer';

export default combineReducers({
  auth,
  user,
  utils,
});
